


































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from "vue-property-decorator";
import CertificateEdit from "./CertificateEdit";
import CertificateConstraintInput from "./CertificateConstraintInput.vue";
import CertificatePipelineTypeInput from "./CertificatePipelineTypeInput.vue";
import CertificateContactEdit from './CertificateContactEdit.vue';
import EventCard from "../event/EventCard.vue";
import ContactModal from "../contact/ContactModal.vue";
import {
	IVIPCertificatePipelineWork,
	createVIPCertificatePipelineWork,
} from "@/loader";

@Component({
	components: {
		CertificatePipelineTypeInput,
		CertificateConstraintInput,
		EventCard,
		ContactModal,
		CertificateContactEdit,
	}
})
export default class CertificateWorkEdit extends CertificateEdit {
	public loadMessage = "Chargement de l'attestation de travaux ...";

	// @ts-ignore
	public focused = {
		// fk_contact: false,
		client: false,
		manager: false,
		designation: false,
		address: false,
		zipcode: false,
		start: false,
		end: false,
		amount: false,
		amountCompany: false,
		subcontracting_amount: false,
		subcontracting_text: false,
		pipeline_armor: false,
	}

	// @ts-ignore
	public invalidFeedbacks = {
		// fk_contact: "Le signataire ne peut pas être vide.",
		client: "Le maître d'oeuvre ne peut pas être vide.",
		manager: "Le maître d'ouvrage ne peut pas être vide.",
		designation: "La désignation ne peut pas être vide.",
		address: "L'adresse ne peut pas être vide.",
		zipcode: "Le code postal ne peut pas être vide.",
		start: "La date de début ne peut pas être vide.",
		end: "La date de fin ne peut pas être vide.",
		amount: "Le montant doit être supérieur à zéro.",
		amountCompany: "La part de l'entreprise doit être supérieur à zéro.",
		subcontracting_amount: "Le montant sous-traité doit être supérieur à zéro.",
		subcontracting_text: "La nature des travaux sous-traités ne peut pas être vide.",
		pipeline_armor: "Le type de blindage ne peut pas être vide.",
	};

	// @ts-ignore
	public get states() {
		return {
			// fk_contact: this.focused.fk_contact ? (this.item.datas.fk_contact || 0) > 0 : null,
			client: this.focused.client ? (this.item.datas.client?.length || 0) > 0 : null,
			manager: this.focused.manager ? (this.item.datas.manager?.length || 0) > 0 : null,
			designation: this.focused.designation ? (this.item.datas.designation?.length || 0) > 0 : null,
			address: this.focused.address ? (this.item.datas.address?.length || 0) > 0 : null,
			zipcode: this.focused.zipcode ? (this.item.datas.zipcode?.length || 0) > 0 : null,
			start: this.focused.start ? (this.item.datas.start?.length || 0) > 0 : null,
			end: this.focused.end ? (this.item.datas.end?.length || 0) > 0 : null,
			amount: this.focused.amount ? (this.item.datas.amount || 0) > 0 : null,
			amountCompany: this.focused.amountCompany ? (this.item.datas.amountCompany || 0) > 0 : null,
			subcontracting_amount: this.focused.subcontracting_amount && this.item.datas.subcontracting?.active ? (this.item.datas.subcontracting.amount || 0) > 0 : null,
			subcontracting_text: this.focused.subcontracting_text && this.item.datas.subcontracting?.active ? (this.item.datas.subcontracting.text?.length || 0) > 0 : null,
			pipeline_armor: this.focused.pipeline_armor ? (this.item.datas.pipeline?.armor?.length || 0) > 0 : null,
		};
	}

	public get needPipeline(): boolean {
		return this.item.project?.ips.some(cip => cip.ip?.pipeline || false) || false;
	}

	public addWork() {
		if (this.item.datas.pipeline) {
			this.item.datas.pipeline.works.push(createVIPCertificatePipelineWork());
			this.focusOn("pipeline_works");
		}
	}

	public removeWork(work: IVIPCertificatePipelineWork) {
		if (this.item.datas.pipeline) {
			this.item.datas.pipeline.works.remove(work);
			this.focusOn("pipeline_works");
		}
	}
}
